import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';

/** Re-runs the active route after allowing failed suspense queries to retry. */
export function useRouteErrorRetry(): () => void {
  const queryErrorResetBoundary = useQueryErrorResetBoundary();
  const router = useRouter();

  return useCallback(() => {
    queryErrorResetBoundary.reset();
    void router.invalidate();
  }, [queryErrorResetBoundary, router]);
}
